// Ported from the Amoreg app's AnimatedWorkflowIcon (apps/web/components/animated-nav-icons.tsx).
// That one drives framer-motion from a ref; Amoreg ships no motion library, so
// the same three beats are CSS keyframes (index.css, "workflow-icon-*") that run
// while the link or button around the icon is hovered.
import type { SVGProps } from "react";

/**
 * Lucide's Workflow glyph, drawn the same, that replays itself when its row
 * is hovered: the first box pops in, the connector draws, the second box pops
 * in. Renders a bare `<svg>` so sidebar rows that style `> svg` still reach it.
 */
export function AnimatedWorkflowIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      data-workflow-icon=""
      {...props}
    >
      <rect width="8" height="8" x="3" y="3" rx="2" data-workflow-icon-box="first" />
      <path d="M7 11v4a2 2 0 0 0 2 2h4" pathLength={1} data-workflow-icon-link="" />
      <rect width="8" height="8" x="13" y="13" rx="2" data-workflow-icon-box="second" />
    </svg>
  );
}
